import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseAreaListComponent } from '@app/components/course-areas/list/course-area-list/course-area-list.component';
import { WelcomeComponent } from '@app/components/welcome/welcome.component';
import { UserService } from '@app/services/user.service';
import { AuthService } from '@app/services/auth.service';
import { UserModel } from '@app/models/user/user.model';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-privacy-policy-update',
  templateUrl: './privacy-policy-update.component.html',
  styleUrls: ['./privacy-policy-update.component.scss']
})
export class PrivacyPolicyUpdateComponent implements OnInit {
  static route: string = 'privacy-update';

  isLoaded: boolean;
  private returnUrl: string;
  userData: UserModel;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private loading: LoadingProvider,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.loading.show();
    this.userService.getUser().subscribe(
      user => {
        this.userData = new UserModel();
        this.userData.hasSeenLatestPolicy = user.hasSeenLatestPolicy;
      },
      err => {},
      () => {
        this.loading.hide();
      }
    );
    this.isLoaded = true;

    // get return url from the route parameters
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
  }

  continue() {
    this.userData.hasSeenLatestPolicy = true;
    this.userService.updateUser(this.userData).subscribe(
      result => {
        if (this.returnUrl != '') {
          this.router.navigate([this.returnUrl]);
        } else {
          // this.router.navigate([`/${PrivacyPolicyUpdateComponent.route}`]);
          if (sessionStorage.getItem('areas-seen') == 'true') {
            this.router.navigate([`/centigrade/${CourseAreaListComponent.route}`]);
          } else {
            this.router.navigate([`/${WelcomeComponent.route}`]);
          }
        }
      },
      error => {}
    );
  }

  logout() {
    this.authService.logout();
    this.router.navigate([`/centigrade`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/legal/privacy-policy-update/privacy-policy-update.component.ts